import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import styled from '@emotion/styled'
import {
  useGuessLikesByArticle,
  useGuessLikesByArticleClassification,
  useGuessLikesByKeyword,
} from 'utils/api/hooks'
import Link from 'components/common/A'
import CursorBox from 'components/common/CursorPointerBox.js'

const GuessLikeImgWrapper = styled.div`
  width: 105px;
  height: 79px;
  min-width: 105px;
  min-height: 79px;
  border-radius: 12px;
  overflow: hidden;
`

const GuessLikeImg = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  background: url('/img/img_headshot_default.png');
  background-size: 100%;
  background-position: center;
`

const GuessLikes = ({ guessLikeData, isGuessLikeLoading, ...prop }) => {
  return (
    <>
      {!!guessLikeData?.length && !isGuessLikeLoading ? (
        <Grid container {...prop}>
          <Typography mb={6} fontWeight="fontWeightBold">
            猜你喜歡
          </Typography>
          <Grid item xs={12}>
            {guessLikeData &&
              guessLikeData?.map((item, index) => {
                return (
                  <Link href={`/article/${item?.urlId}`} key={item?.urlId}>
                    <CursorBox
                      display="flex"
                      alignItems="center"
                      mb={index < guessLikeData.length - 1 ? 6 : 0}
                    >
                      <GuessLikeImgWrapper>
                        <GuessLikeImg src={item?.image?.url} />
                      </GuessLikeImgWrapper>
                      <Typography
                        variant="paraBodyMedium"
                        color="text.minus2"
                        ml={3}
                      >
                        {item?.title}
                      </Typography>
                    </CursorBox>
                  </Link>
                )
              })}
          </Grid>
        </Grid>
      ) : null}
    </>
  )
}

const GuessLikesList = ({
  article,
  articleClassification,
  keyword,
  ...props
}) => {
  let guessLikeData
  let isGuessLikeLoading
  if (article?._id) {
    const { data, isLoading } = useGuessLikesByArticle(article?._id)
    guessLikeData = data
    isGuessLikeLoading = isLoading
  } else if (articleClassification?._id) {
    const { data, isLoading } = useGuessLikesByArticleClassification(
      articleClassification?._id
    )
    guessLikeData = data
    isGuessLikeLoading = isLoading
  } else if (keyword) {
    const { data, isLoading } = useGuessLikesByKeyword(keyword)
    guessLikeData = data
    isGuessLikeLoading = isLoading
  }
  return (
    <GuessLikes
      guessLikeData={guessLikeData}
      isGuessLikeLoading={isGuessLikeLoading}
      {...props}
    ></GuessLikes>
  )
}

export default GuessLikesList
